import { render, staticRenderFns } from "./Controllo.vue?vue&type=template&id=254e59e4&scoped=true&"
import script from "./Controllo.vue?vue&type=script&lang=js&"
export * from "./Controllo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e59e4",
  null
  
)

export default component.exports